<template>
    <!-- Filter leads -->
    <div>
        <div
            class="form-group"
            :class="[
                {
                    'form-row': horizontal,
                },
            ]"
        >
            <label
                v-if="label"
                :class="[
                    { 'col-form-label': horizontal },
                    horizontal ? classLabelComponent : '',
                    size == 'sm' ? 'col-form-label-sm' : '',
                ]"
            >
                {{ label }}
            </label>
            <div
                :class="[
                    horizontal ? classInputComponent : '',
                    size == 'sm' ? 'input-group-sm' : '',
                ]"
            >
                <CButton
                    :block="block"
                    :color="color"
                    :disabled="disabled"
                    :type="type"
                    class="button shadow d-flex add-button"
                    @click="openModal()"
                >
                    <span class="button__icon">
                        <CIcon :content="$options.icons.cilPlus" />
                    </span>
                    <span class="button__text">
                        <slot>
                            {{ "List values" }}
                        </slot>
                    </span>
                </CButton>
            </div>
        </div>
        <CModal
            color="secondary"
            :show.sync="modals.tableSettings.show"
            :closeOnBackdrop="false"
        >
            <template #header>
                <h4 class="m-0">
                    <CIcon :content="$options.icons.cilSettings" />
                    <span :style="{ 'padding-left': '10px' }">
                        {{ "List values" }}
                    </span>
                </h4>
            </template>

            <CContainer>
                <CRow>
                    <CCol>
                        <CTextarea
                            :placeholder="'List values'"
                            :value.sync="valueComponentAsString"
                            size="sm"
                        >
                        </CTextarea>
                    </CCol>
                </CRow>
            </CContainer>

            <template #footer-wrapper>
                <CContainer class="pt-3 pb-2">
                    <CRow :form="true">
                        <CCol md="6"> </CCol>
                        <CCol md="6">
                            <CContainer>
                                <CRow alignHorizontal="end">
                                    <CButton @click="eventCancel()">
                                        {{ "Cancel" }}
                                    </CButton>
                                    <CButton @click="eventSave()">
                                        {{ "Save" }}
                                    </CButton>
                                </CRow>
                            </CContainer>
                        </CCol>
                    </CRow>
                </CContainer>
            </template>
        </CModal>
    </div>
</template>

<script>
/** Components */
import { ModelSelect } from "vue-search-select";
/** Mixins */
import baseMixin from "~/mixins/base.js";

/** Others */
import {
    cilFilter,
    cilListFilter,
    cilSettings,
    cilX,
    cilLockLocked,
    cilPlus,
} from "@coreui/icons";
import "vue-search-select/dist/VueSearchSelect.css";
export default {
    name: "InputList",
    mixins: [baseMixin],
    icons: {
        cilFilter,
        cilListFilter,
        cilSettings,
        cilX,
        cilLockLocked,
        cilPlus,
    },
    components: {
        ModelSelect,
    },
    data() {
        return {
            modals: {
                tableSettings: {
                    show: false,
                },
            },
            valueComponent: [],
            classLabelComponent: "col-sm-3",
            classInputComponent: "col-sm-9",
        };
    },
    props: {
        value: {
            type: Array,
            default: () => {
                return [];
            },
        },
        label: {
            type: String,
            default: null,
        },
        size: {
            default: undefined,
        },
        horizontal: {
            default: false,
        },
        block: {
            type: Boolean,
            default: false,
        },
        color: {
            default: "success",
            type: String,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        type: String,
        title: {
            type: String,
        },
    },
    watch: {
        value(newValue) {
            if (Array.isArray(newValue)) {
                this.valueComponent = newValue;
            }
        },
    },
    computed: {
        valueComponentAsString: {
            get() {
                return this.valueComponent.join(",");
            },
            // setter
            set(newValue) {
                let items = [];
                if (newValue != "") {
                    items = newValue.split(",");
                }
                items = items.map((item) => {
                    return item.trim();
                });
                this.valueComponent = items;
            },
        },
    },
    methods: {
        openModal() {
            this.modals.tableSettings.show = true;
        },
        closeModal() {
            this.modals.tableSettings.show = false;
        },
        eventSave() {
            this.$emit("update:value", this.valueComponent);
            this.$emit("change", this.valueComponent);
            this.closeModal();
        },
        eventCancel() {
            this.closeModal();
        },
        setHorizontalClass: function () {
            if (this.horizontal.label) {
                this.classLabelComponent = this.horizontal.label;
            }
            if (this.horizontal.input) {
                this.classInputComponent = this.horizontal.input;
            }
        },
    },
    mounted() {
        if (Array.isArray(this.value)) {
            this.valueComponent = this.value;
        }
        this.setHorizontalClass();
    },
};
</script>

<style lang="scss" scoped>
.list-fields__wrapped {
    max-height: 50vh;
    overflow-y: auto;
}
.button__text {
    width: 100%;
}
</style>
